import React from "react";
import { InvoiceFormPage } from "./Invoice";
import InvoicePrint from "./Print";
import { StitchFormShell } from "../../../../shared-ui/StitchFormShell";

export function StitchInvoiceFormPage() {
  return (
    <StitchFormShell
      crumbs={["Operations", "ZOrder", "Invoice"]}
      title="Invoice form"
      description="Create or edit an invoice. Amounts remain server-authoritative."
    >
      <InvoiceFormPage />
    </StitchFormShell>
  );
}

export function StitchInvoicePrintPage() {
  return (
    <StitchFormShell
      crumbs={["Operations", "ZOrder", "Invoice Print"]}
      title="Invoice document"
      description="Printable invoice from live data."
      print
    >
      <InvoicePrint />
    </StitchFormShell>
  );
}

export default StitchInvoiceFormPage;
